export default function InitInfrastructureForm() {
    const form = document.querySelector('.infrastructure_form form');
    if(!form)
        return;
        
    const addressField = form.querySelector('input[name="adressobjekt"]');
    const buttonSubmit = form.querySelector('[type="submit"]');
    const errorField = form.querySelector('.address .input-error');

    buttonSubmit.addEventListener('click', (event) => {
        if(!addressField.value){
            event.preventDefault();
            errorField.innerHTML = "Bitte gültige Adresse aus Liste auswählen";
        }

        
    });  
}